import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchStreams, fetchStream, fetchGroup } from 'actions/streams';
import { fetchCollections, fetchCollection, fetchCollectionSection } from 'actions/collections';
import { searchAssets, invalidateAssetsSearch } from 'actions/assets';
import { selectAsset, selectCollection, invalidateAssetSelection } from 'actions/selection';
import errorMessage from "../images/404errorMessage.svg";
import _ from 'lodash';
import cx from "classnames";
import dateFormat from 'dateformat';

import {
  Row, Col, Image, Media, Button, Tabs, Tab,
  InputGroup, FormControl, Accordion, Card, OverlayTrigger, Tooltip
} from "react-bootstrap";

import InfiniteScroll from "react-infinite-scroller";
import Truncate from "react-truncate";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper, faFileAlt, faFolderOpen, faFolder } from '@fortawesome/free-regular-svg-icons';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

import FileService from 'services/file.service';

import styles from './components.module.scss';
import { trackAdoptionMetricsForAssetDetailViewedEvent, trackAdoptionMetricsForCollectionDetailViewedEvent, trackAdoptionMetricsForContentSearchedEvent, trackAdoptionMetricsForStreamDetailViewedEvent } from 'actions/adoption';

const defaultAccountIcon = "images/default_user_profile_background.png";
const PaperfliteIcon = "images/logo.png";

const webAppUrl = process.env.REACT_APP_WEBAPP_URL;

export default function ContentView(props) {
  const dispatch = useDispatch();
  const searching = useSelector((state) => _.get(state, 'assets.search.query') != '');
  const hubEnabled = useSelector((state) => _.get(state, 'users.account.item.hubEnabled'));
  const userRole = useSelector((state) => _.get(state, 'users.profile.item.userRoles[0]'));
  const profileLoading = useSelector((state) => _.get(state, 'users.profile.loading'));


  const [query, setQuery] = useState('');

  const handleSearchChanged = React.useCallback(
    _.debounce((query) => {
    
      if (query != "") {   
        dispatch(searchAssets(query, 0, 20));
      } else {
        dispatch(invalidateAssetsSearch());
      }

      dispatch(trackAdoptionMetricsForContentSearchedEvent("Content Searched", "Content Library", query, "Assets", "", "", _.capitalize(props.source)));
      setQuery(query); 
    }, 500),[]);

    const collectionsAccess =_.get(userRole,'collection.access');
    const streamsAccess = _.get(userRole,'hub.access');
    const searchAccess = _.get(userRole,'search.access');

  return (
    <div className={styles.content}>
      <Row>
        <Col md={12}>
          <ProfileView />
        </Col>
       { (collectionsAccess || streamsAccess ) && searchAccess &&   
        <Col md={12} className={cx(styles.search)}>
          <InputGroup className={cx(styles.inputGroup)}>
            <InputGroup.Prepend>
              <InputGroup.Text id="basic-addon1"><span className="paperflite-search"></span></InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              placeholder="Type here to search"
              aria-label="Search"
              aria-describedby="basic-addon1"
              onChange={(e) => {
                handleSearchChanged(e.target.value);
              }}
            />
          </InputGroup>
        </Col>}
        <Col md={12}>
          {searching &&
            <SearchResult query={query} source={props.source}/>
          }
          {!searching && (collectionsAccess || streamsAccess )  &&
            <Tabs  className={styles.tabs}>
             {collectionsAccess &&  
              <Tab eventKey="collections" title="My Collections">
                <MyCollections source={props.source}/>
              </Tab>
             }
              {streamsAccess && hubEnabled &&
                <Tab eventKey="streams" title="My Streams">
                  <MyStreams source={props.source}/>
                </Tab>
              }
            </Tabs>
          }
          {!profileLoading && !collectionsAccess && !streamsAccess &&
            <div className={styles.errorMessage}>
              <img src={errorMessage} />
              <span className={styles.subtext}>It looks like you ‘Do Nut’ have the access to the Collections and Streams. Contact your Admin for further clarification</span>
            </div>
          }
          {profileLoading && 
            <div className={styles.loadingApplication}>Loading Application...</div>
          }
        </Col>
      </Row>
    </div>
  )
}

function ProfileView() {
  const profile = useSelector(state => state.users.profile.item);
  const account = useSelector(state => state.users.account.item);

  return (
    <Row>
      {profile &&
        <div>
          <Col md={9}>
            <Image
              width={200} className={cx(styles.companyLogo, "align-items-center")}
              src={(account && account.logo.thumbnail) || defaultAccountIcon}
            />
          </Col>
          <Col md={3} className="d-flex pr-0">
            <Media className="align-items-center">
              <Image
                width={24}
                src={PaperfliteIcon}
              />
              <Media.Body>
                <div className={styles.poweredByText}> Powered by paperflite </div>
              </Media.Body>
            </Media>
          </Col>
          <Col md={12} className={styles.profileName}>
            From {profile.firstName}'s Content
          </Col>
        </div>
      }
    </Row>
  )
}

function SearchResult(props) {
  const dispatch = useDispatch();

  const query = useSelector((state) => _.get(state, 'assets.search.query'));
  const loading = useSelector((state) => _.get(state, 'assets.search.searching'));
  const assets = useSelector((state) => _.get(state, 'assets.search.items')) || [];
  const currentPage = useSelector((state) => _.get(state, 'assets.search.pagination.current'));
  const totalPages = useSelector((state) => _.get(state, 'assets.search.pagination.totalPages'));

  const initialLoading = loading && assets.length === 0;

  const loadMoreItems = () => {
    if (loading) {
      return;
    }

    dispatch(searchAssets(query, currentPage + 1, 20));
  }


  return (
    <div className={styles.searchResults}>
      {initialLoading &&
        <div className={cx(styles.loading, styles.initial)}>Searching assets...</div>
      }

      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={currentPage < totalPages}
        loadMore={() => { loadMoreItems() }}
        useWindow={false}
        threshold={150}
      >
        {!loading && assets.length == 0 &&
          <div className={styles.empty}>No results found</div>
        }

        {assets.map(asset => <SearchAssetNode key={asset.id} asset={asset} source={props.source}/>)}

        {!initialLoading && loading &&
          <div className={styles.loading}>Loading more...</div>
        }
      </InfiniteScroll>
    </div>
  );
}

function MyCollections({source}) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => _.get(state, 'collections.loading'));
  const collections = useSelector((state) => _.get(state, 'collections.items')) || [];
  const currentPage = useSelector((state) => _.get(state, 'collections.pagination.current'));
  const totalPages = useSelector((state) => _.get(state, 'collections.pagination.totalPages'));

  const initialLoading = loading && collections.length === 0;

  useEffect(() => {
    dispatch(fetchCollections(0, 20));
  }, [])

  const loadMoreItems = () => {
    if (loading) {
      return;
    }

    dispatch(fetchCollections(currentPage + 1, 20));
  }

  return (
    <div className={styles.collections}>
      {initialLoading &&
        <div className={cx(styles.loading, styles.initial)}>Loading collections...</div>
      }

      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={currentPage < totalPages}
        loadMore={() => { loadMoreItems() }}
        useWindow={false}
        threshold={150}
      >
        {collections.filter(collection => {
          return collection.id != "uncategorized" && !collection.internal && !collection.dealRoom
        }).map(collection => <CollectionNode key={collection.id} content={collection} source={source}/>)}

        {!initialLoading && loading &&
          <div className={styles.loading}>Loading more...</div>
        }
      </InfiniteScroll>
    </div>
  );
}

function MyStreams({source}) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => _.get(state, 'streams.loading'));
  const streams = useSelector((state) => _.get(state, 'streams.items')) || [];

  useEffect(() => {
    dispatch(fetchStreams());
  }, []);

  return (
    <div className={styles.streams}>
      {loading &&
        <div className={styles.loadingMessage}>Loading...</div>
      }

      {streams.map(stream => <StreamNode key={stream.id} stream={stream} source={source}/>)}
    </div>
  );
}

function CollectionNode({ content, source }) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const loading = useSelector(state => _.get(state, `collections.collection.${content.id}.loading`, false));
  const collection = useSelector(state => _.get(state, `collections.collection.${content.id}.item`, null));

  const handleClick = () => {
    setOpen(!open);
    if(source){
      dispatch(trackAdoptionMetricsForCollectionDetailViewedEvent("Collection Detail Viewed", _.get(content, "name", ""), _.capitalize(source)));
    }
    if (!loaded) {
      dispatch(fetchCollection(content.id));
      setLoaded(true);
    }
  }

  var children = _.get(collection, 'sections') || [];
  if (_.size(children) === 0) {
    children = _.get(collection, 'assets') || [];
  }

  return (
    <Accordion className={cx(styles.accordion, styles.border, styles.collection)} key={content.id}>
      <Card className={styles.card}>
        <Accordion.Toggle as={Card.Header} eventKey={content.id} >
          <div className={cx(styles.row, styles.collection)} onClick={handleClick}>
            <FontAwesomeIcon icon={open ? faMinus : faPlus} className={cx(styles.icon, styles.expand)} size="sm" color="#E51058" />
            <FontAwesomeIcon icon={faNewspaper} className={styles.icon} size="sm" />
            <div className={styles.name}>
              <Truncate lines={2}>{content.name}</Truncate>
            </div>
            {content.type === 'user_defined' &&
              <>
                <div className={styles.actions}>
                  <PreviewButton title='Preview Collection' url={`${webAppUrl}/collections/${content.id}?source=${source}`} />
                  <AttachIcon label='Attach Collection' entity={content} onAttach= {(collection) => {
                    dispatch(selectCollection(collection));
                  }}/>
                </div>
              </>
            }
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={content.id}>
          <Card.Body>
            {loading && children.length === 0 &&
              <div className={styles.loading}>Fetching children...</div>
            }
            {children.map(item => {
              if (item.entityType === 'collection_section') {
                return <CollectionSectionNode key={item.id} parent={content.id} content={item} source={source}/>
              } else if (item.entityType === 'asset') {
                return <AssetNode key={item.id} asset={item} source={source}/>
              }
              return false;
            })}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

function CollectionSectionNode({ content, parent, source }) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const handleClick = () => {
    setOpen(!open);
    if (!loaded) {
      dispatch(fetchCollectionSection(parent, content.id));
      setLoaded(true);
    }
  }

  const children = _.get(content, 'assets') || [];
  const loading = _.get(content, 'loading', false) && children.length === 0;

  return (
    <Accordion
      className={styles.accordion}
      key={content.id}
    >
      <Card className={styles.card}>
        <Accordion.Toggle as={Card.Header} eventKey={content.id} onClick={handleClick}>
          <div className={cx(styles.row, styles.collectionSection)}>
            <FontAwesomeIcon icon={open ? faMinus : faPlus} className={cx(styles.icon, styles.expand)} size="sm" color="#E51058" />
            <FontAwesomeIcon icon={faNewspaper} className={styles.icon} size="sm" />
            <div className={styles.name}>
              <Truncate lines={2}>{content.name}</Truncate>
            </div>
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={content.id}>
          <Card.Body>
            {loading &&
              <div className={styles.loading}>Fetching children...</div>
            }

            {children.map(item => {
              if (item.entityType === 'asset') {
                return <AssetNode key={item.id} asset={item} source={source}/>
              }

              return false;
            })}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

function AssetNode({ asset, source }) {
  const dispatch = useDispatch();

  const handleAssetClick = () => {
    if(source){
      dispatch(trackAdoptionMetricsForAssetDetailViewedEvent("Asset Detail Viewed", "Content Library", FileService.fileType(_.get(asset, "metadata")), _.capitalize(source)));
    }
  }

  return (
    <div className={cx(styles.row, styles.asset)} key={asset.id} onClick={() => {
      dispatch(selectAsset(asset));
    }}>
      <Image className={styles.icon} src={FileService.getIcon(asset)} width={18} height={18} />
      <div className={styles.details}>
        <div className={styles.name}>
          <Truncate lines={2}>{asset.name}</Truncate>
        </div>
        <div className={styles.meta}>
          {FileService.fileType(asset.metadata)} | Updated {dateFormat(asset.contentModifiedDate, 'dd mmm yyyy')}
        </div>
      </div>

      <div className={styles.actions}>
        <PreviewButton title='Preview Asset' url={`${webAppUrl}/assets/${asset.id}?source=${source}`} handleAssetClick={handleAssetClick}/>

        {_.get(asset, 'settings.share') &&
          <AttachIcon label='Add Asset' entity={asset} onAttach= {(asset) => {
            dispatch(selectAsset(asset));
          }}/>
        }
      </div>
    </div>
  );
}

function StreamNode({ stream, source }) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const handleClick = () => {
    setOpen(!open);
    if(source){
      dispatch(trackAdoptionMetricsForStreamDetailViewedEvent("Stream Detail Viewed", _.get(stream, "name", ""), _.capitalize(source)));
    }
    if (!loaded) {
      dispatch(fetchStream(stream.id));
      setLoaded(true);
    }
  }

  const children = useSelector(state => _.get(state, `streams.stream.${stream.id}.item.children`, []));
  const loading = useSelector(state => _.get(state, `streams.stream.${stream.id}.loading`, false)) && children.length == 0;

  return (
    <Accordion
      className={cx(styles.accordion, styles.border)}
      key={stream.id}
    >
      <Card className={styles.card}>
        <Accordion.Toggle as={Card.Header} eventKey={stream.id} onClick={handleClick}>
          <div className={cx(styles.row, styles.stream)}>
            <FontAwesomeIcon icon={open ? faMinus : faPlus} className={cx(styles.icon, styles.expand)} size="sm" color="#E51058" />
            <FontAwesomeIcon icon={faNewspaper} className={styles.icon} size="sm" />
            <div className={styles.name}>
              <Truncate lines={2}>{stream.name}</Truncate>
            </div>
            <div className={styles.actions}>
              <PreviewButton title='Preview Stream' url={`${webAppUrl}/streams/${stream.id}?source=${source}`} />
            </div>
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={stream.id}>
          <Card.Body>
            {loading &&
              <div className={styles.loading}>Fetching children...</div>
            }

            {children.filter(item => item.entityType === 'group').map(item => {
              return <GroupNode key={item.id} group={item} source={source}/>
            })}

            {children.filter(item => item.entityType === 'asset').map(item => {
              return <AssetNode key={item.id} asset={item} source={source}/>
            })}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

function GroupNode({ group, source }) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const handleClick = () => {
    setOpen(!open);
    if (!loaded) {
      dispatch(fetchGroup(group.id));
      setLoaded(true);
    }
  }

  const loading = useSelector(state => _.get(state, `streams.group.${group.id}.loading`, false));
  const children = useSelector(state => _.get(state, `streams.group.${group.id}.item.children`, []));

  return (
    <Accordion
      className={cx(styles.accordion, styles.border)}
      key={group.id}
    >
      <Card className={styles.card}>
        <Accordion.Toggle as={Card.Header} eventKey={group.id} onClick={handleClick}>
          <div className={cx(styles.row, styles.group)}>
            <FontAwesomeIcon icon={open ? faMinus : faPlus} className={cx(styles.icon, styles.expand)} size="sm" color="#E51058" />
            <FontAwesomeIcon icon={open ? faFolderOpen : faFolder} className={styles.icon} size="sm" />
            <div className={styles.name}>
              <Truncate lines={2}>{group.name}</Truncate>
            </div>
            <div className={styles.actions}>
              <PreviewButton title='Preview Group' url={`${webAppUrl}/groups/${group.id}`} />
            </div>
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={group.id}>
          <Card.Body>
            {loading &&
              <div className={styles.loading}>Fetching children...</div>
            }

            {children.map(item => {
              if (item.entityType === 'group') {
                return <GroupNode key={item.id} group={item} source={source}/>
              } else if (item.entityType === 'asset') {
                return <AssetNode key={item.id} asset={item} source={source}/>
              }

              return false;
            })}

          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

function PreviewButton({ title, url, handleAssetClick }) {
  const [icon, setIcon] = useState('/images/preview.png');
  const onMouseOver = () => {
    setIcon('/images/preview-active.png')
  }

  const onMouseOut = () => {
    setIcon('/images/preview.png')
  }

  const handleClick = () => {
      handleAssetClick && handleAssetClick();
  }

  return (
    <OverlayTrigger
      placement='top'
      overlay={
        <Tooltip id={`preview_tooltip`} className={styles.tooltip}>{title}</Tooltip>
      }
    >
      <Button
        variant="link"
        onMouseEnter={onMouseOver}
        onMouseLeave={onMouseOut}
        href={url}
        target="_blank"
        onClick={() => handleClick()}
        >
        <Image src={icon} width={16} height={16} />
      </Button>
    </OverlayTrigger>
  );
}

function AttachIcon({ label, entity, onAttach }) {
  const dispatch = useDispatch();
  const [icon, setIcon] = useState('/images/attach.png')

  
  const onMouseOver = () => {
    setIcon('/images/attach-active.png')
  }

  const onMouseOut = () => {
    setIcon('/images/attach.png')
  }

  return (
    <OverlayTrigger
      placement='top'
      overlay={
        <Tooltip id={`get_link_tooltip`} className={styles.tooltip}>{label}</Tooltip>
      }
    >
      <Button
        variant="link"
        onMouseEnter={onMouseOver}
        onMouseLeave={onMouseOut}
        onClick={(e) => {
          e.stopPropagation();
          onAttach(entity);
        }}
      >
        <Image src={icon} width={16} height={16} />
      </Button>
    </OverlayTrigger>
  );
}

function SearchAssetNode({ asset, source }) {
  const dispatch = useDispatch();
  
  const icon = _.get(asset, 'icon.thumbnail') || "/images/default_asset.jpg"

  const handleAssetClick = () => {
    if(source){
      dispatch(trackAdoptionMetricsForAssetDetailViewedEvent("Asset Detail Viewed", "Content Libary", FileService.fileType(_.get(asset, "metadata")), _.capitalize(source)));
    }
  }

  return (
    <div className={cx(styles.row, styles.asset, styles.search)} key={asset.id} onClick={() => {
      dispatch(selectAsset(asset));
    }}>
      <Image className={styles.icon} src={icon} width={36} height={36} />
      <div className={styles.details}>
        <div className={styles.name}>
          <Truncate lines={2}>{asset.name}</Truncate>
        </div>
        <div className={styles.meta}>
          {FileService.fileType(asset.metadata)} | Updated {dateFormat(asset.contentModifiedDate, 'dd mmm yyyy')}
        </div>
      </div>

      <div className={styles.actions}>
        <PreviewButton title='Preview Asset' url={`${webAppUrl}/assets/${asset.id}?source=${source}`} handleAssetClick={handleAssetClick}/>

        {_.get(asset, 'settings.share') &&
          <AttachIcon label='Add Asset' entity={asset} onAttach= {(asset) => {
            dispatch(selectAsset(asset));
          }}/>
        }
      </div>
    </div>
  );
}

function LockIcon({ size }) {

  const [state, setState] = React.useState({
    width: size || 24,
    height: size || 24,
  })
 
  return (
      <div className={styles.lock}>
        <div className={styles.icon} style={state}>
          <div className={styles.inner}>
            <span className={styles.image} />
          </div>
        </div>
      </div>
  );
}